import { connect } from "react-redux";
import ConsultDeposit from "../components/ConsultDeposit";
import { setInformations, resetAllProps, requestGetFiles, readyToSend, setReadyToSend, removeToaster, setValueSelect } from "../actions";

function mapStateToProps(state) {
    return {
        emailsList: state.emailsList,
        toaster: state.toaster,
        listFiles: state.listFiles,
        readyToSend: state.readyToSend,
        valueSelect: state.valueSelect
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            setInformations: (depositInformations) => {
                dispatch(setInformations(depositInformations));
            },
            resetAllProps: () => {
                dispatch(resetAllProps());
            },
            getFiles: () => {
                dispatch(requestGetFiles());
            },
            readyToSend: () => {
                dispatch(readyToSend());
            },
            setReadyToSend: (check) => {
                dispatch(setReadyToSend(check));
            },
            removeToaster: () => {
                dispatch(removeToaster());
            },
            setValueSelect: (value) => {
                dispatch(setValueSelect(value))
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultDeposit);